import * as Sentry from '@sentry/react'
import { ConfigProvider, Spin } from 'antd'
import React, { Suspense } from 'react'
import { render } from 'react-dom'
import Authenticator from './Components/Authenticator'
import ErrorBoundary from './Components/ErrorBoundary'
import { GoogleScript } from './Components/GoogleScript'
import I18n from './Components/I18n'
import {
  ASSET_SERVICE,
  APP_SENTRY_LOGGING,
} from './Constants'
import setupAppSentry from './Constants/Sentry/setupAppSentry'
import { setHeaderSentry } from './Constants/Sentry/headerSentry'
import { CONTENT_STYLE } from './Styles'
import { Router } from './Components/Router'

__webpack_public_path__ = `${ASSET_SERVICE}/`

// Store a copy of the Sentry instance from the header.
setHeaderSentry(Sentry.getCurrentHub())

if (APP_SENTRY_LOGGING) {
  setupAppSentry()
}

const App = (): JSX.Element => (
  <ConfigProvider>
    <I18n>
      <GoogleScript>
        <Suspense fallback={<Spin />}>
          <ErrorBoundary>
            <Authenticator>
              <section style={CONTENT_STYLE}>
                <Router />
              </section>
            </Authenticator>
          </ErrorBoundary>
        </Suspense>
      </GoogleScript>
    </I18n>
  </ConfigProvider>
)

render(<App />, document.querySelector('app-root'))
